const initialState = {
	isLoading: false,
	byId: {}
}

export default function reducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		case 'REQUEST_FACEBOOK_DATA':
			return {
				...state,
				isLoading: true
			}

		case 'RECEIVE_FACEBOOK_DATA':
			return {
				...state,
				byId: payload
			}
	}

	return state
}
